(function () {
  document.querySelectorAll('.lumera-pdp-v2[data-lumera-pdp-v2]').forEach(function (root) {
    var gallery = initGallery(root);
    initVariantPicker(root, gallery);
    initQuantity(root);
    initAddToCart(root);
  });

  function initGallery(root) {
    var hero = root.querySelector('.hero');
    var slides = hero ? Array.prototype.slice.call(hero.querySelectorAll('[data-lv2-hero-slide]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lv2-thumb]'));

    function show(index) {
      slides.forEach(function (s) { s.classList.toggle('active', Number(s.dataset.index) === index); });
      thumbs.forEach(function (t) { t.classList.toggle('active', Number(t.dataset.index) === index); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(Number(thumb.dataset.index)); });
    });

    return {
      showMedia: function (mediaId) {
        var slide = slides.filter(function (s) { return s.dataset.mediaId === String(mediaId); })[0];
        if (slide) show(Number(slide.dataset.index));
      },
    };
  }

  function initVariantPicker(root, gallery) {
    var form = root.querySelector('[data-lv2-product-form]');
    var jsonEl = root.querySelector('[data-lv2-product-json]');
    if (!jsonEl || !form) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var optionButtons = root.querySelectorAll('[data-lv2-option-value-button]');
    var optionBlocks = root.querySelectorAll('.option-block');
    var selected = [];
    optionBlocks.forEach(function (block) {
      var selectedButton = block.querySelector('.sw.selected');
      selected[Number(block.dataset.optionIndex)] = selectedButton ? selectedButton.dataset.value : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        return selected.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }

    function currentQty() {
      var input = root.querySelector('[data-lv2-qty-input]');
      return Math.max(1, parseInt(input && input.value, 10) || 1);
    }

    function render() {
      var variant = findVariant();

      optionBlocks.forEach(function (block) {
        var index = Number(block.dataset.optionIndex);
        var valueLabel = block.querySelector('[data-lv2-option-value]');
        if (valueLabel && selected[index]) valueLabel.textContent = selected[index];
      });
      optionButtons.forEach(function (button) {
        var index = Number(button.dataset.optionIndex);
        button.classList.toggle('selected', button.dataset.value === selected[index]);
      });

      var priceEl = root.querySelector('[data-lv2-price]');
      var comparePriceEl = root.querySelector('[data-lv2-compare-price]');
      var addButton = root.querySelector('[data-lv2-add-to-cart]');
      var stickyAddButton = root.querySelector('[data-lv2-add-to-cart-sticky]');
      var addLabel = root.querySelector('[data-lv2-add-label]');
      var stickyPriceEl = root.querySelector('[data-lv2-sticky-price]');
      var variantIdInput = root.querySelector('[data-lv2-variant-id]');

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (stickyAddButton) stickyAddButton.disabled = true;
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      var qty = currentQty();
      var unitPrice = Lumera.formatMoney(variant.price);
      var totalPrice = Lumera.formatMoney(variant.price * qty);

      if (priceEl) {
        priceEl.textContent = unitPrice;
        priceEl.classList.toggle('on-sale', variant.compare_at_price > variant.price);
      }
      if (comparePriceEl) {
        comparePriceEl.style.display = variant.compare_at_price > variant.price ? '' : 'none';
        if (variant.compare_at_price > variant.price) comparePriceEl.textContent = Lumera.formatMoney(variant.compare_at_price);
      }
      if (stickyPriceEl) stickyPriceEl.textContent = totalPrice;

      if (addButton) addButton.disabled = !variant.available;
      if (stickyAddButton) stickyAddButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart — ' + totalPrice : 'Sold Out';
      if (stickyAddButton) stickyAddButton.textContent = variant.available ? 'Add to cart' : 'Sold Out';

      if (variant.featured_media && gallery) gallery.showMedia(variant.featured_media.id);
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = Number(button.dataset.optionIndex);
        selected[index] = button.dataset.value;
        render();
      });
    });

    root.updateSummary = render;
  }

  function initQuantity(root) {
    var input = root.querySelector('[data-lv2-qty-input]');
    var valueEl = root.querySelector('[data-lv2-qty-value]');
    var decrease = root.querySelector('[data-lv2-qty-decrease]');
    var increase = root.querySelector('[data-lv2-qty-increase]');
    if (!input) return;

    function set(next) {
      input.value = Math.max(1, next);
      if (valueEl) valueEl.textContent = input.value;
      if (root.updateSummary) root.updateSummary();
    }

    decrease && decrease.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
    increase && increase.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
  }

  function initAddToCart(root) {
    var form = root.querySelector('[data-lv2-product-form]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var addButton = root.querySelector('[data-lv2-add-to-cart]');
      var stickyButton = root.querySelector('[data-lv2-add-to-cart-sticky]');
      var feedback = root.querySelector('[data-lv2-cart-feedback]');
      var variantId = form.querySelector('[data-lv2-variant-id]').value;
      var quantity = parseInt(form.querySelector('[data-lv2-qty-input]').value, 10) || 1;

      if (addButton) { addButton.classList.add('loading'); addButton.disabled = true; }
      if (stickyButton) stickyButton.disabled = true;

      Lumera.addToCart(variantId, quantity)
        .then(function () {
          if (feedback) { feedback.textContent = 'Added to cart'; feedback.className = 'cart-feedback show'; }
        })
        .catch(function (error) {
          if (feedback) { feedback.textContent = error.message || 'Could not add to cart'; feedback.className = 'cart-feedback show error'; }
        })
        .finally(function () {
          if (addButton) { addButton.classList.remove('loading'); addButton.disabled = false; }
          if (stickyButton) stickyButton.disabled = false;
        });
    });

    // Sticky bar's button submits the same form via form="LumeraProductFormV2" so no separate handler needed.
  }
})();
